import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  PagedResultDto,
  TimesheetRequest,
  TimesheetWithEntry
} from '@umss/shared/data-access';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimesheetService {
  private http = inject(HttpClient);

  private readonly baseUrl = '/api/Timesheets';

  getEntries(
    payload?: Partial<TimesheetRequest>
  ): Observable<PagedResultDto<TimesheetWithEntry>> {
    const params = HttpHelper.toHttpParams(payload ?? {});
    return this.http.get<PagedResultDto<TimesheetWithEntry>>(
      `${this.baseUrl}/entries`,
      {
        params
      }
    );
  }
}
